import type React from "react";
import { useEffect, useState } from "react";
import type { EscalationRule, Product } from "@qbanq/shared";
import { api } from "../api/client";

const OPERATORS: EscalationRule["operator"][] = [
  "contains",
  "not_contains",
  "regex",
  "outside_business_hours",
  "message_count_gte",
  "sentiment_negative",
];

export function EscalationRulesPage() {
  const [products, setProducts] = useState<Product[]>([]);
  const [rules, setRules] = useState<EscalationRule[]>([]);
  const [productId, setProductId] = useState("");
  const [name, setName] = useState("");
  const [operator, setOperator] = useState<EscalationRule["operator"]>("contains");
  const [value, setValue] = useState("");

  function load() {
    void api.get<Product[]>("/api/products").then((p) => {
      setProducts(p);
      if (!productId && p[0]) setProductId(p[0].id);
    });
    void api.get<EscalationRule[]>("/api/escalation-rules").then(setRules);
  }
  useEffect(load, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    await api.post("/api/escalation-rules", { product_id: productId, name, operator, value });
    setName("");
    setValue("");
    load();
  }

  async function remove(id: string) {
    await api.del(`/api/escalation-rules/${id}`);
    load();
  }

  const valuined = operator === "outside_business_hours" || operator === "sentiment_negative";

  return (
    <div>
      <h2>Escalation Rules</h2>
      <p className="muted">Rules are evaluated (lowest priority first) on each inbound message; a match opens a handoff and suppresses AI.</p>
      <div className="card">
        <form onSubmit={create}>
          <div className="row">
            <div className="field" style={{ flex: 1 }}>
              <label>Product</label>
              <select value={productId} onChange={(e) => setProductId(e.target.value)}>
                {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <div className="field" style={{ flex: 1 }}>
              <label>Operator</label>
              <select value={operator} onChange={(e) => setOperator(e.target.value as EscalationRule["operator"])}>
                {OPERATORS.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>
          </div>
          <div className="field">
            <label>Name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          {!valuined && (
            <div className="field">
              <label>Value (keyword / regex / threshold)</label>
              <input value={value} onChange={(e) => setValue(e.target.value)} />
            </div>
          )}
          <button className="btn" type="submit">Add rule</button>
        </form>
      </div>

      <div className="card">
        <table>
          <thead><tr><th>Name</th><th>Operator</th><th>Value</th><th>Product</th><th></th></tr></thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.id}>
                <td>{r.name}</td>
                <td className="muted">{r.operator}</td>
                <td>{r.value ?? "—"}</td>
                <td>{products.find((p) => p.id === r.product_id)?.name ?? r.product_id}</td>
                <td><button className="btn danger" onClick={() => remove(r.id)}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
